<template>
	<div>
		<nav class="navbar navbar-expand-md navbar-light bg-light border-bottom d-block d-md-none">
			<div class="container-fluid">
				<div class="navbar-brand d-flex align-items-center">
					<img src="@/assets/img/kmib-logo.png" class="me-2" style="height: 32px;" />
					<span>KMIB EDU Exam</span>
				</div>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="navbarCollapse">
					<ul class="navbar-nav me-auto mb-2 mb-md-0">
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle" href="javascript://" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								{{appModel.getLang().toUpperCase()}}
							</a>
							<ul class="dropdown-menu">
								<li v-for="(langname, langkey) in appModel.langsName" :key="'lang-'+langkey">
									<a class="dropdown-item" :class="{'active': langkey == appModel.getLang()}" href="javascript://" @click="appModel.setLang(langkey)">{{langname}}</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</nav>
		<div class="container-fluid">
			<div class="row">
				<main class="col-12 ms-sm-auto px-md-4">
					<div class="d-md-flex justify-content-between align-items-center py-3 mb-3 border-bottom">
						<div class="d-none d-md-flex align-items-md-center">
							<img src="@/assets/img/kmib-logo.png" class="me-2" style="width: 40px;" />
							<h5 class="mb-0">KMIB EDU Exam</h5>
						</div>
						<div class="d-grid d-md-flex gap-2">
							<div class="text-center text-md-end py-2 py-md-0 me-md-3">
								<div v-if="exam">
									<span v-for="(discipline, index) in exam.disciplines" :key="discipline.id">
										<span>{{discipline.name}}</span>
										<span v-if="index < exam.disciplines.length - 1">, </span>
									</span>
								</div>
								<div v-if="student">{{student.fio}}</div>
							</div>
							<div class="btn-toolbar mb-2 mb-md-0 gap-2 d-flex">
								<button type="button" @click="onFinishExam()" class="btn flex-fill flex-md-none btn-outline-danger" v-if="!loading && exam">{{$t('btn.finish-exam')}}</button>
								<button type="button" class="btn flex-fill flex-md-none btn-outline-secondary" :content="$t('tooltip.btn.exam-timer')" v-tippy="{placement: 'bottom'}" v-if="!loading && exam && student">
									<vue-countdown :time="calculateRemainingTime()" @end="onFinishExamByTimer()" v-slot="{days, hours, minutes, seconds}">
										{{hours < 10 ? 0 : ''}}{{hours}}:{{minutes < 10 ? 0 : ''}}{{minutes}}:{{seconds < 10 ? 0 : ''}}{{seconds}}
									</vue-countdown>
								</button>
								<div class="btn-group d-none d-md-inline-flex" role="group">
									<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
										{{appModel.getLang().toUpperCase()}}
									</button>
									<ul class="dropdown-menu">
										<li v-for="(langname, langkey) in appModel.langsName" :key="'lang-'+langkey">
											<a class="dropdown-item" :class="{'active': langkey == appModel.getLang()}" href="javascript://" @click="appModel.setLang(langkey)">{{langname}}</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="text-center" v-if="loading">
						<loading-spinner
							:overlay="loading"
							:text="$t('text.loading-data')"
						></loading-spinner>
					</div>
					<div class="row gap-2 gap-md-0" v-else>
						<div class="col-md-8">
							<div class="card">
								<div class="card-body" v-if="selQuestion">
									<div class="text-muted text-center">{{$t('text.question')}} № {{selQuestionNum}}</div>
									<h4 class="mb-0 text-center">{{selQuestion.text}}</h4>
									<div class="text-center mt-2">
										<img :src="selQuestion.img" style="width: auto; max-width: 100%;" v-if="selQuestion.img" />
									</div>
									<div class="d-flex align-items-center justify-content-center mt-4">
										<div class="list-group list-group-radio d-grid gap-2 border-0">
											<div class="position-relative" v-for="answer in selQuestion.answers" :key="answer.id">
												<input class="form-check-input position-absolute top-50 start-0 ms-3 fs-5" type="radio" name="listGroupRadioGrid" :id="'listGroupRadioGrid'+answer.id" :value="answer.id" v-model="selQuestion.answer_id" @change="onChangeAnswer()" />
												<label class="list-group-item py-3 ps-5" :for="'listGroupRadioGrid'+answer.id">
													<div>{{answer.text}}</div>
													<img :src="answer.img" class="mt-2" style="width: auto; max-width: 100%;" v-if="answer.img" />
												</label>
											</div>
										</div>
									</div>
									<div class="d-flex align-items-center justify-content-between mt-4">
										<div class="btn btn-outline-secondary" @click="onPrevQuestion()">
											<font-awesome-icon :icon="['fas', 'chevron-left']" class="me-2" />
											<span class="d-none d-md-inline">{{$t('btn.prev-question')}}</span>
											<span class="d-md-none">{{$t('btn.prev-question-cut')}}</span>
										</div>
										<div class="btn btn-outline-secondary" @click="onNextQuestion()">
											<span class="d-none d-md-inline">{{$t('btn.next-question')}}</span>
											<span class="d-md-none">{{$t('btn.next-question-cut')}}</span>
											<font-awesome-icon :icon="['fas', 'chevron-right']" class="ms-2" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="card text-center">
								<div class="card-body">
									<h5 class="mb-0">{{$t('header.questions-numbers')}}</h5>
									<div class="text-muted">({{$t('text.total-answers')}} {{questions.filter(el => el.sended).length}} {{$t('text.total-answers-from')}} {{questions.length}})</div>
									<div class="mt-3">
										<div class="btn rounded-5 m-1" :class="{
											'btn-primary': question.id == sel_question_id,
											'btn-outline-secondary': question.id != sel_question_id && !question.sended,
											'btn-success': question.id != sel_question_id && question.answer_id && question.sended
										}" style="min-width: 45px;" @click="onToggleQuestion(question)" v-for="(question, index) in questions" :key="question.id">
											<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="question.loading" />
											<span v-else>{{index + 1}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
						{{error}}
						<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
					</div>
				</main>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.list-group {
	width: 100%;
}
.form-check-input:checked + .form-checked-content {
	opacity: .5;
}
.form-check-input-placeholder {
	border-style: dashed;
}
[contenteditable]:focus {
	outline: 0;
}
.list-group-checkable .list-group-item {
	cursor: pointer;
}
.list-group-item-check {
	position: absolute;
	clip: rect(0, 0, 0, 0);
}
.list-group-item-check:hover + .list-group-item {
	background-color: var(--bs-secondary-bg);
}
.list-group-item-check:checked + .list-group-item {
	color: #fff;
	background-color: var(--bs-primary);
	border-color: var(--bs-primary);
}
.list-group-item-check[disabled] + .list-group-item,
.list-group-item-check:disabled + .list-group-item {
	pointer-events: none;
	filter: none;
	opacity: .5;
}
.list-group-radio .list-group-item {
cursor: pointer;
	border-radius: .5rem;
}
.list-group-radio .form-check-input {
	z-index: 2;
	margin-top: -.5em;
}
.list-group-radio .list-group-item:hover,
.list-group-radio .list-group-item:focus {
	background-color: var(--bs-secondary-bg);
}
.list-group-radio .form-check-input:checked + .list-group-item {
	background-color: var(--bs-body);
	border-color: var(--bs-primary);
	box-shadow: 0 0 0 2px var(--bs-primary);
}
.list-group-radio .form-check-input[disabled] + .list-group-item,
.list-group-radio .form-check-input:disabled + .list-group-item {
	pointer-events: none;
	filter: none;
	opacity: .5;
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'KMIB EDU Exam'});
	},
	data: () => ({
		sel_question_id: '',
		
		exam: null,
		student: null,
		questions: [],
		
		loading: false,
		error: '',
	}),
	computed: {
		selQuestion(){
			return this.questions.find(el => el.id == this.sel_question_id);
		},
		selQuestionNum(){
			return this.questions.findIndex(el => el.id == this.sel_question_id) + 1;
		},
	},
	methods: {
		calculateRemainingTime(){
			const examStartTime = new Date(this.student.date_start.replace(/-/g, '/')+' UTC').getTime();
			const examDuration = this.exam.timer * 60 * 1000;
			const examEndTime = examStartTime + examDuration;
			const currentTime = new Date().getTime();
			return examEndTime - currentTime;
		},
		async loadExam(){
			this.loading = true;
			this.error = '';
			const ret = await this.appModel.doGetExam(this.appModel.sel_exam_id);
			if(ret.success){
				this.exam = ret.item;
			} else {
				this.error = ret.error;
			}
			this.loading = false;
		},
		async loadStudent(){
			this.loading = true;
			this.error = '';
			const ret = await this.appModel.doGetExamStudent(this.appModel.sel_exam_id, this.appModel.sel_student_id);
			if(ret.success){
				this.student = ret.item;
			} else {
				this.error = ret.error;
			}
			this.loading = false;
		},
		async loadExamStudentQuestions(){
			this.loading = true;
			this.error = '';
			const ret = await this.appModel.doGetExamStudentQuestions(this.appModel.sel_exam_id, this.appModel.sel_student_id);
			if(ret.success){
				this.questions = ret.list.map(el => {
					el.loading = false;
					el.sended = !!el.answer_id;
					return el;
				});
				if(this.questions.length > 0){
					this.sel_question_id = this.questions[0].id;
					const notanswered = this.questions.filter(el => !el.answer_id).length;
					if(notanswered > 0 && this.selQuestion.answer_id){
						this.onNextNotAnsweredQuestion();
					}
				}
			} else {
				this.error = ret.error;
			}
			this.loading = false;
		},
		
		onToggleQuestion(question){
			this.sel_question_id = question.id;
		},
		onPrevQuestion(){
			const index = this.questions.findIndex(el => el.id == this.sel_question_id);
			if(index > 0){
				this.sel_question_id = this.questions[index - 1].id;
			} else {
				this.sel_question_id = this.questions[this.questions.length - 1].id;

			}
		},
		onNextQuestion(){
			const index = this.questions.findIndex(el => el.id == this.sel_question_id);
			if(index < this.questions.length - 1){
				this.sel_question_id = this.questions[index + 1].id;
			} else {
				this.sel_question_id = this.questions[0].id;
			}
		},
		onNextNotAnsweredQuestion(){
			const notanswered = this.questions.filter(el => !el.answer_id).length;
			if(notanswered > 0){
				let index = this.questions.findIndex(el => el.id == this.sel_question_id);
				do {
					index++;
					if(index > this.questions.length - 1) index = 0;
				} while(this.questions[index].answer_id)
				this.sel_question_id = this.questions[index].id;
			} else {
				const index = this.questions.findIndex(el => el.id == this.sel_question_id);
				if(index < this.questions.length - 1){
					this.sel_question_id = this.questions[index + 1].id;
				} else {
					this.sel_question_id = this.questions[0].id;
				}
			}
		},
		
		async onChangeAnswer(){
			const q = _.cloneDeep(this.selQuestion);
			
			const notanswered = this.questions.filter(el => !el.answer_id).length;
			if(notanswered > 0){
				this.onNextNotAnsweredQuestion();
			}
			
			const question = this.questions.find(el => el.id == q.id);
			question.loading = true;
			const ret = await this.appModel.doSetExamStudentQuestionAnswer(this.appModel.sel_exam_id, this.appModel.sel_student_id, question.id, question.answer_id);
			if(ret.success){
				question.sended = true;
			}
			question.loading = false;
			
			if(notanswered <= 0){
				this.onFinishExam();
			}
		},
		
		onFinishExam(){
			this.$swal({
				title: this.$t('title.confirm-finish-exam'),
				html: `
					<div>${this.$t('text.confirm-finish-exam')}</div>
					<div class="alert alert-warning mt-4 mb-0">${this.$t('text.warning.confirm-finish-exam')}</div>
				`,
				icon: 'question',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-lg btn-outline-danger mb-2 me-2',
				cancelButtonClass: 'btn btn-lg btn-outline-primary mb-2',
				confirmButtonText: this.$t('btn.finish-exam2'),
				cancelButtonText: this.$t('btn.back-to-exam'),
				buttonsStyling: false,
			}).then(async (result) => {
				if(result.isConfirmed){
					let sel_exam_id = this.appModel.sel_exam_id;
					let sel_student_id = this.appModel.sel_student_id;
					const ret = await this.appModel.doFinishExam(this.appModel.sel_exam_id, this.appModel.sel_student_id);
					if(ret.success){
						if(this.exam.is_show_results){
							let results_text = `
								<li class="list-group-item d-grid gap-2 d-md-flex justify-content-center justify-content-md-between align-items-center">
									<div>${this.$t('text.results.100-ball-system')}</div>
									<div class="badge fs-6 text-bg-primary">${ret.results.percent}</div>
								</li>
							`;
							for(const sres of ret.results.grades){
								results_text += `
									<li class="list-group-item d-grid gap-2 d-md-flex justify-content-center justify-content-md-between align-items-center">
										<div>${sres['group_name_'+this.appModel.getLang()]}</div>
										<div class="badge fs-6 text-bg-primary">${sres['grade_value_'+this.appModel.getLang()]}</div>
									</li>
								`;
							}
							this.$swal({
								title: this.$t('title.exam-finished'),
								html: `
									<div>${this.$t('text.exam-finished-by-student')}</div>
									<div class="mt-3">
										<div>${this.$t('text.your-results')}:</div>
										<ul class="list-group mt-2">
											${results_text}
										</ul>
									</div>
									<div class="mt-3 text-center">
										<a href="/api/pdf/report-student-answers/${sel_exam_id}/${sel_student_id}?lang=${this.appModel.getLang()}" target="_blank" class="btn btn-lg btn-secondary">${this.$t('btn.answers')}</a>
									</div>
								`,
								icon: 'success',
								confirmButtonClass: "btn btn-lg btn-primary",
								buttonsStyling: false,
								timer: 15000,
							}).then((result) => {
								this.$router.push({path: '/logout'});
							});
						} else {
							this.$swal({
								title: this.$t('title.exam-finished'),
								text: this.$t('text.exam-finished-by-student'),
								icon: 'success',
								confirmButtonClass: "btn btn-lg btn-primary",
								buttonsStyling: false,
								timer: 5000,
							}).then(async (result) => {
								this.$router.push({path: '/logout'});
							});
						}
					} else {
						this.error = ret.error;
					}
				}
			});
		},
		async onFinishExamByTimer(){
			let sel_exam_id = this.appModel.sel_exam_id;
			let sel_student_id = this.appModel.sel_student_id;
			const ret = await this.appModel.doFinishExam(this.appModel.sel_exam_id, this.appModel.sel_student_id);
			if(ret.success){
				if(this.exam.is_show_results){
					let results_text = `
						<li class="list-group-item d-grid gap-2 d-md-flex justify-content-center justify-content-md-between align-items-center">
							<div>${this.$t('text.results.100-ball-system')}</div>
							<div class="badge fs-6 text-bg-primary">${ret.results.percent}</div>
						</li>
					`;
					for(const sres of ret.results.grades){
						results_text += `
							<li class="list-group-item d-grid gap-2 d-md-flex justify-content-center justify-content-md-between align-items-center">
								<div>${sres['group_name_'+this.appModel.getLang()]}</div>
								<div class="badge fs-6 text-bg-primary">${sres['grade_value_'+this.appModel.getLang()]}</div>
							</li>
						`;
					}
					this.$swal({
						title: this.$t('title.exam-finished'),
						html: `
							<div>${this.$t('text.exam-finished-by-timer')}</div>
							<div class="mt-3">
								<div>${this.$t('text.your-results')}:</div>
								<ul class="list-group mt-2">
									${results_text}
								</ul>
							</div>
							<div class="mt-3 text-center">
									<a href="/api/pdf/report-student-answers/${sel_exam_id}/${sel_student_id}?lang=${this.appModel.getLang()}" target="_blank" class="btn btn-lg btn-secondary">${this.$t('btn.answers')}</a>
								</div>
						`,
						icon: 'success',
						confirmButtonClass: "btn btn-lg btn-primary",
						buttonsStyling: false,
						timer: 15000,
					}).then((result) => {
						this.$router.push({path: '/logout'});
					});
				} else {
					this.$swal({
						title: this.$t('title.exam-finished'),
						text: this.$t('text.exam-finished-by-timer'),
						icon: 'success',
						confirmButtonClass: "btn btn-lg btn-primary",
						buttonsStyling: false,
						timer: 5000,
					}).then((result) => {
						this.$router.push({path: '/logout'});
					});
				}
			} else {
				this.error = ret.error;
			}
		},
	},
	async mounted(){
		this.appModel.pageTitle = 'title.exam';
		
		await this.loadExam();
		if(!this.exam){
			this.$swal({
				title: this.$t('title.exam-not-found-or-finished'),
				icon: 'warning',
				confirmButtonClass: "btn btn-lg btn-primary",
				buttonsStyling: false,
				timer: 5000,
			}).then((result) => {
				this.$router.push({path: '/logout'});
			});
		}
		const examDate = new Date(this.exam.date);
		const currentDate = new Date();
		const examDateLocal = new Date(examDate.getFullYear(), examDate.getMonth(), examDate.getDate());
		const currentDateLocal = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
		if(currentDateLocal > examDateLocal){
			this.$swal({
				title: this.$t('title.exam-finished'),
				icon: 'warning',
				confirmButtonClass: "btn btn-lg btn-primary",
				buttonsStyling: false,
				timer: 5000,
			}).then((result) => {
				this.$router.push({path: '/logout'});
			});
		} else if(currentDateLocal < examDateLocal){
			this.$swal({
				title: this.$t('title.exam-not-started'),
				text: this.$t('text.exam-not-started'),
				icon: 'warning',
				confirmButtonClass: "btn btn-lg btn-primary",
				buttonsStyling: false,
				timer: 5000,
			}).then((result) => {
				this.$router.push({path: '/logout'});
			});
		}
		
		await this.loadStudent();
		if(!this.student){
			this.$swal({
				title: this.$t('title.student-not-found'),
				icon: 'warning',
				confirmButtonClass: "btn btn-lg btn-primary",
				buttonsStyling: false,
				timer: 5000,
			}).then((result) => {
				this.$router.push({path: '/logout'});
			});
		}
		if(this.student.status == 'ended'){
			this.$swal({
				title: this.$t('title.exam-finished'),
				icon: 'warning',
				confirmButtonClass: "btn btn-lg btn-primary",
				buttonsStyling: false,
				timer: 5000,
			}).then((result) => {
				this.$router.push({path: '/logout'});
			});
		}
		
		await this.loadExamStudentQuestions();
		const notanswered = this.questions.filter(el => !el.answer_id).length;
		if(notanswered <= 0){
			this.onFinishExam();
		}
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isAdmin()){
				this.$router.push({path: '/admin'});
			} else if(this.authModel.isEditor()){
				this.$router.push({path: '/editor'});
			} else if(!this.appModel.isExamStarted()){
				this.$router.push({path: '/'});
			}
		}
		document.body.classList.add('bg-light');
	},
	beforeUnmount(){
		document.body.classList.remove('bg-light');
	},
	beforeRouteUpdate(to, from, next){
		document.body.classList.add('bg-light');
		//window.scrollTo(0, 0);
		next();
	},
	components: {
		LoadingSpinner,
	},
};
</script>